export const HomeDetailsCardComponent = ({ card }) => {
  return (
    <div className="card">
      <div className="cardImage">
        <img src={card.Image} alt={card.Description.Title} />
      </div>
      <div className="cardOverlay">
        <h3>{card.Description.Title}</h3>
        <p className="subtitle">{card.Description.Subtitle}</p>
        <p className="text">{card.Description.Text}</p>
      </div>
    </div>
  );
};

export default HomeDetailsCardComponent;